document.addEventListener("DOMContentLoaded", function() {
  function updateTexts() {
    let wishlistHeading = document.querySelector("#shopify-section-template--18922116087994__heading h1.hdt-collection-heading");
    let wishlistButton = document.querySelector("#shopify-section-template--18922116087994__main .hdt-btn");

    // Detect current language from switcher
    let currentLangElement = document.querySelector("li.current a[data-language-code]");
    let currentLang = currentLangElement ? currentLangElement.getAttribute("data-language-code") : "ja"; // default Japanese

    if (currentLang === "en") {
      if (wishlistHeading) wishlistHeading.textContent = "Your wishlist";
      if (wishlistButton) wishlistButton.textContent = "Back to shop";
    } else {
      if (wishlistHeading) wishlistHeading.textContent = "ウィッシュリスト";
      if (wishlistButton) wishlistButton.textContent = "ショップに戻る";
    }
  }

  // Run immediately
  updateTexts();

  // Faster interval check (every 200ms instead of 1s)
  setInterval(updateTexts, 200);

  // Observe language switcher for instant reaction
  let switcher = document.querySelector("li.current")?.parentNode;
  if (switcher) {
    const observer = new MutationObserver(updateTexts);
    observer.observe(switcher, { childList: true, subtree: true, attributes: true });
  }
});
